export class CompleteContext {
    // 工作项ID
    workItemId: string;
    // Pass:通过 Back:驳回 Refuse:拒绝 以及自定义，来自Action.Code
    conclusionValue: string;
    // 审批意见
    comment: string;
    // 加签人
    signAssignees: string[];
    // 跳转活动
    destinationActivityId: string;
}
